import { RootState } from 'editor/src/store/index';

const getFocusedMediaElementUuidSelector = (state: RootState) => state.editor.focusedMediaElementUuid;

export default getFocusedMediaElementUuidSelector;
